import { Stage, WorkflowTemplate } from "./WorkflowTemplate";


export class WorkflowTemplateEditorScreenData {
    
    workflow: WorkflowTemplate;
    availableUsers: any[];
    availableStages: any[];
    addStageDialog: boolean = false;
    newStageName: string = '';
    // newStageUser: string = '';
    showStageDetails: boolean = false;
    selectedStage: Stage = null;
    selectedStageIndex: number = -1;
    myCurrentBagOfInstances: any = {};
    indicateTableKey: boolean = false;
    newTableKey: string = '';
    newReason: boolean = false;
    newClassicRender: boolean = false;
    newCheap: boolean = false;
    snackbar: Object;
    showErrors: boolean = false;
    showErrorsDialog: boolean = false;
    loadingSave: boolean = false;
    availableTypes: string[] = []
    availableEntityTypes: any[];
    workflow_input: string = 'document';
    availableWorkflows: any[] = [];
    

    constructor(){
        this.workflow = new WorkflowTemplate(null, [], '');
        this.availableUsers = []
        this.availableStages = [];
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
        }
        this.availableEntityTypes = [];
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
      }
    
      error_message(message){
          this.snackbar['text'] = message
          this.snackbar['color'] = 'error'
          this.snackbar['isVisible'] = true
      }
    
}